/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	/**
	 * Fetch data-url; if it comes back EMPTY and a data-url-fallback is present, try that.
	 * Used so a surface can ask for intent=complementary first (cross-category "completes the
	 * outfit") and drop to intent=related only when a product has no complements curated —
	 * without that fallback a new product would show an empty recommendations panel.
	 * Elements with no data-url-fallback behave exactly as before.
	 */
	fetchProducts() {
		const urls = [this.dataset.url];
		if (this.dataset.urlFallback) { urls.push(this.dataset.urlFallback); }
		this.fetchFrom(urls, 0);
	}
	fetchFrom(urls, i) {
		if (i >= urls.length) {
			this.classList.add('product-recommendations--loaded');
			return;
		}
		fetch(urls[i])
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');
				const inner = recommendations ? recommendations.innerHTML.trim() : '';

				if (!inner.length) {          // nothing for this intent — try the next one
					this.fetchFrom(urls, i + 1);
					return;
				}

				this.innerHTML = inner;

				if ( this.parent ) {
					this.parent.classList.add('product-recommendations--full');

					if ( OverlayManager.isOpen(document.getElementById('Cart-Drawer'))) {
						this.parent.classList.add('active');
					}
				}

				this.classList.add('product-recommendations--loaded');

			})
			.catch(e => {
				console.error(e);
				this.fetchFrom(urls, i + 1);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);
